module.exports = __webpack_public_path__ + "img/AR.5f52183e.png";